import React, { useEffect } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import usePageLoadedSubscriber from '@atlassian/jira-spa-state-controller/src/components/page-loaded-state/index.tsx';
import { RenderAfterHydrationCompletion } from '@atlassian/jira-ssr-toolkit/src/RenderAfterHydrationCompletion.tsx';

type JIRA_READY_STATUS = {
	/**
	 * the absence of this field means nothing has started yet
	 */
	started: boolean;
	/**
	 * indicates whether the page has finished loading "main blocks". In does not mean it's loaded
	 * @deprecated use readyForInteractions instead
	 */
	loaded: boolean;
	/**
	 * indicates that UFO send FINISH_INTERACTION
	 * @deprecated use readyForInteractions instead
	 */
	onhold: boolean;
	/**
	 * indicates the page readyness to for user interactions
	 */
	readyForInteractions?: boolean;
};

const setReadyStatus = (status: Partial<JIRA_READY_STATUS>) => {
	if (typeof window !== 'undefined' && window.__JIRA_READY_STATUS) {
		window.__JIRA_READY_STATUS = Object.assign(window.__JIRA_READY_STATUS, status);
	}
};

const ReportApplicationReady = () => {
	useEffect(() => {
		setReadyStatus({
			readyForInteractions: true,
		});
	}, []);
	return null;
};

export const ReadinessTracker = () => {
	useEffect(() => {
		if (typeof window !== 'undefined') {
			window.__JIRA_READY_STATUS = {
				started: true,
				loaded: false,
				onhold: true,
			};
			if (fg('jfp_magma_jira-refactor-readyness-event')) {
				setReadyStatus({ readyForInteractions: false });
			}
		}
	}, []);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			const onPageReady = () => {
				window.__JIRA_READY_STATUS.onhold = false;
			};
			window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
			return () => {
				window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
			};
		}
	}, []);

	const [{ hasLoaded }] = usePageLoadedSubscriber();

	useEffect(() => {
		if (hasLoaded) {
			if (typeof window !== 'undefined') {
				// we track "loaded" status as jira "loading end"
				window.__JIRA_READY_STATUS.loaded = true;
			}
		}
	}, [hasLoaded]);

	if (!fg('jfp_magma_jira-refactor-readyness-event')) {
		return null;
	}

	return (
		<RenderAfterHydrationCompletion>
			<ReportApplicationReady />
		</RenderAfterHydrationCompletion>
	);
};
